import { AdminFormSettings } from 'src/app/hickory-api';
import { IDENTITY_PROVIDERS_AUTHZ_DOMAIN } from 'src/app/shared/authentication/access-control';

export * from './identity-providers.datasource';
export * from './identity-provider-table-context';
export * from './selected-dentity-provider-context';

export interface IdpSelectionResult {
  id?: number;
  scheme?: string;
  name?: string;
  type?: AdminFormSettings.SignOnMethodEnum | 'UseExisting';
}

export class IdpModels {
  public static readonly HEADER_MARGIN = '0 0 16px 0';
  public static readonly ICON = 'token';
  public static readonly DOMAIN = IDENTITY_PROVIDERS_AUTHZ_DOMAIN;
}